import { EstadoValidacionNacionalI } from "interfaces/EstadoValidacionNacional";

export interface infoFetchEstadoValidacionNacionalI {
  id: number | string;
  nombre: string;
  borderColor: string;
  backgroundColor: string;
  textColor: string;
}

class EstadoValidacionNacional implements EstadoValidacionNacionalI {
  id: number | string;
  nombre: string;
  borderColor: string;
  backgroundColor: string;
  textColor: string;

  constructor(infoFetch: infoFetchEstadoValidacionNacionalI) {
    this.id = infoFetch.id;
    this.nombre = infoFetch.nombre;
    this.borderColor = infoFetch.borderColor;
    this.backgroundColor = infoFetch.backgroundColor;
    this.textColor = infoFetch.textColor;
  }
}

export const makeEstadoValidacionNacional = (
  infoFetch: infoFetchEstadoValidacionNacionalI,
) => {
  return new EstadoValidacionNacional(infoFetch);
};
